/**
 * Appointments Async Thunks
 * All async actions for appointments operations
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as appointmentsApi from '../api/appointmentsApi';

/**
 * Fetch appointments with filters
 */
export const fetchAppointmentsThunk = createAsyncThunk(
  'appointments/fetchAppointments',
  async (params, { rejectWithValue }) => {
    try {
      const data = await appointmentsApi.fetchAppointments(params);
      return data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Fetch upcoming appointments
 */
export const fetchUpcomingAppointmentsThunk = createAsyncThunk(
  'appointments/fetchUpcoming',
  async (params, { rejectWithValue }) => {
    try {
      const data = await appointmentsApi.fetchUpcomingAppointments(params);
      return data;
    } catch (error) {
      console.error('Error fetching upcoming appointments:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Create new appointment
 */
export const createAppointmentThunk = createAsyncThunk(
  'appointments/createAppointment',
  async (data, { rejectWithValue }) => {
    try {
      const result = await appointmentsApi.createAppointment(data);
      return result;
    } catch (error) {
      console.error('Error creating appointment:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Update appointment
 */
export const updateAppointmentThunk = createAsyncThunk(
  'appointments/updateAppointment',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const result = await appointmentsApi.updateAppointment(id, data);
      return result;
    } catch (error) {
      console.error('Error updating appointment:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Delete appointment
 */
export const deleteAppointmentThunk = createAsyncThunk(
  'appointments/deleteAppointment',
  async (id, { rejectWithValue }) => {
    try {
      const data = await appointmentsApi.deleteAppointment(id);
      return data;
    } catch (error) {
      console.error('Error deleting appointment:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
